import { valibotResolver } from "@hookform/resolvers/valibot";
import { Plus } from "@phosphor-icons/react";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { Button } from "common/components/ui/Button";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useAgencyDomainsMutations from "../../../datahooks/useAgencyDomainsMutations";
import useAgencySettingsMutations from "../../../datahooks/useAgencySettingsMutations";
import {
  AgencyDomainSchema,
  type AgencyDomainSchemaType,
} from "../../../schema";

export default function AddDomain() {
  const isDesktop = useTwBreakpoint("lg");
  const { addAgencyDomain, isAddingAgencyDomain } = useAgencyDomainsMutations();
  const { updateAgencySettings, isUpdatingAgencySettings } =
    useAgencySettingsMutations();
  const [isAdding, setIsAdding] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      domainName: "",
    },
    resolver: valibotResolver(AgencyDomainSchema),
  });

  function onSubmit({ domainName }: AgencyDomainSchemaType) {
    updateAgencySettings({ updates: { domain: domainName } }).then(() => {
      addAgencyDomain({ domainName });
    });
  }

  if (isAdding) {
    return (
      <FormField
        label="Custom domain"
        htmlFor="domain-url"
        size={isDesktop ? "sm" : "lg"}
        error={errors.domainName?.message}
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex gap-x-2 gap-y-4 flex-col lg:flex-row"
        >
          <Input
            {...register("domainName")}
            variant={isDesktop ? "sm" : "lg"}
            placeholder="Enter custom domain"
            className="lg:w-80"
            id="domain-url"
          />
          <div className="flex gap-x-2">
            <Button
              variant="secondary-black"
              className="ml-auto"
              size={isDesktop ? "sm" : "md"}
              onClick={() => {
                setIsAdding(false);
                reset();
              }}
              disabled={isAddingAgencyDomain || isUpdatingAgencySettings}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="secondary-purple"
              size={isDesktop ? "sm" : "md"}
              isLoading={isAddingAgencyDomain || isUpdatingAgencySettings}
            >
              Add
            </Button>
          </div>
        </form>
      </FormField>
    );
  }
  return (
    <Button
      variant="outline-black"
      leftIcon={<Plus />}
      size={isDesktop ? "sm" : "md"}
      className="mr-auto"
      onClick={() => setIsAdding(true)}
    >
      Add custom domain
    </Button>
  );
}
